export const breakPoints = {
  high_resolution: 1600,
  desktop_large: 1290,
  desktop: 1102,
  tablet: 768,
  mobile: 576,
  mobile_m: 381,
  mobile_s: 320,
};
